import { Box, PictogramType, Typography } from '@internations/ds'
import { ReactElement } from 'react'

type StepHeaderProps = { Pictogram: PictogramType; heading: string; caption?: string; desktopJustifyContent?: string }

export default function StepHeader({
    Pictogram,
    heading,
    caption,
    desktopJustifyContent,
}: StepHeaderProps): ReactElement {
    const sectionHeading = (
        <Box textAlign={['center', 'left']}>
            <Typography variant="h2">{heading}</Typography>
            {caption ? (
                <Typography variant="body2" color="textSecondary">
                    {caption}
                </Typography>
            ) : null}
        </Box>
    )
    return (
        <>
            <Box display={['flex', 'none']} flexDirection="column" alignItems="center" justifyContent="center" mb={3}>
                <Box mb={1}>
                    <Pictogram />
                </Box>
                {sectionHeading}
            </Box>
            <Box
                display={['none', 'flex']}
                alignItems="center"
                justifyContent={desktopJustifyContent ?? 'center'}
                mb={3}
            >
                <Box alignSelf={['center', 'start']}>
                    <Pictogram size="medium" />
                </Box>
                <Box ml={1} maxWidth="400px">
                    {sectionHeading}
                </Box>
            </Box>
        </>
    )
}
